import Script from "next/script";
import React from "react";
import { useLoyaltyToken } from "./hooks";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { useUser } from "@frend-digital/centra/client";
import { useParams } from "next/navigation";
import { parseGeo } from "@frend-digital/next/i18n";
import { getYotpoGuid, isLoyaltyMarket } from "./market-config";

export const widgetsLoadedAtom = atom(false);

export const LoyaltyScripts = () => {
	const setWidgetsLoaded = useSetAtom(widgetsLoadedAtom);

	const { data: user, error } = useUser();
	const token = useLoyaltyToken();
	const params = useParams<{ geo: string }>();

	const userCountry = user?.country;
	const geoCountry = (() => {
		const parsed = parseGeo(params.geo ?? "en-NO");
		return parsed.err ? "NO" : parsed.val.country;
	})();
	const country = userCountry && isLoyaltyMarket(userCountry) ? userCountry : geoCountry;
	const guid = getYotpoGuid(country);

	const userLoading = !user && !error;

	if (userLoading) return null;

	if (user) {
		if (!token) return null;
		return (
			<>
				<div
					id="swell-customer-identification"
					data-authenticated
					data-email={user.email}
					data-token={token}
					data-tags='["VIP"]'
					style={{ display: "none" }}
				/>

				<Script
					src={`https://cdn-loyalty.yotpo.com/loader/${guid}.js`}
					async
				/>
				<Script
					src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${guid}`}
					async
					onLoad={() => setWidgetsLoaded(true)}
				/>
			</>
		);
	}

	return (
		<>
			<Script src={`https://cdn-loyalty.yotpo.com/loader/${guid}.js`} async />
			<Script
				src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${guid}`}
				async
				onLoad={() => setWidgetsLoaded(true)}
			/>
		</>
	);
};

export const useLoyaltyReady = () => {
	const loaded = useAtomValue(widgetsLoadedAtom);
	return loaded;
};
